/**
 * Fonte única do patientId da aba: mantém `localStorage.patientId` e
 * `sessionStorage.patientId` iguais.
 *
 * O funil (ensureSignupSession, /registration/start), a triagem e o cache do
 * prontuário resolvem o id pelo sessionStorage primeiro; o gate do chat, a
 * telemetria e o Persistence resolviam pelo localStorage primeiro. Com os dois
 * divergentes, a triagem era salva num id e o chat procurava o prontuário em
 * outro — `chat_redirected_no_triage` logo após `prontuario_persisted` e a
 * triagem recomeçando do zero (caso Neiva 23/09/2026).
 *
 * Em divergência vence o sessionStorage: é o id da própria aba e é nele que o
 * funil gravou cadastro, triagem e cache no servidor. O localStorage é
 * compartilhado entre abas e pode ter sido sobrescrito por outra.
 */

const KEY = 'patientId';

const read = (storage) => {
  try {
    const v = storage.getItem(KEY);
    return v ? String(v) : null;
  } catch {
    return null;
  }
};

const write = (storage, value) => {
  try {
    storage.setItem(KEY, value);
  } catch {}
};

/**
 * @param {{ onDiverged?: (info: { patientId: string, discardedId: string }) => void }} [opts]
 * @returns {string|null} patientId vigente da aba (ou null se não houver)
 */
export function reconcilePatientIdStorage({ onDiverged } = {}) {
  const ss = typeof sessionStorage !== 'undefined' ? read(sessionStorage) : null;
  const ls = typeof localStorage !== 'undefined' ? read(localStorage) : null;
  const pid = ss || ls;
  if (!pid) return null;
  if (ls !== pid && typeof localStorage !== 'undefined') write(localStorage, pid);
  if (ss !== pid && typeof sessionStorage !== 'undefined') write(sessionStorage, pid);
  if (ls && ss && ls !== ss && typeof onDiverged === 'function') {
    try {
      onDiverged({ patientId: pid, discardedId: ls });
    } catch {}
  }
  return pid;
}
